import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  card: {
    borderRadius: 20,
    padding: "12px 10px 20px 10px",
    backgroundColor: "#FFF",
    border: "2px solid #E5E5E5",
  },
  cardHdr: {
    alignItems: "center",
    justifyContent: "space-between",
    padding: "3px 10px 15px 10px",
    borderBottom: "1px solid #D4D4D4",
  },
  cardHdng: {
    fontFamily: "Inter",
    fontSize: 24,
    fontWeight: 700,
    color: "#000",
    margin: 0,
  },
  cardHdrTotal: {
    display: "flex",
    alignItems: "center",
    "& p": {
      margin: 0,
      fontFamily: "Inter",
    },
    "& .totalLabel": {
      fontSize: 20,
      fontWeight: 700,
      color: "#000",
      marginRight: 5,
    },
    "& .cost": {
      fontSize: 20,
      fontWeight: 700,
      color: "#00A991",
    },
    "& .duration": {
      fontSize: 14,
      fontWeight: 400,
      color: "#000",
    },
  },
  tablesParent: {
    marginTop: 22,
    marginInline: 10,
    display: "flex",
    overflow: "auto",
    borderRadius: 8,
    border: "1px solid #E5E5E5",
    [theme.fn.smallerThan("sm")]: {
      flexDirection: "column",
    },
  },
  tableParent1: {
    width: "40%",
    [theme.fn.smallerThan("sm")]: {
      width: "100%",
      borderBottom: "1px solid #E5E5E5",
    },
  },
  tableParent2: {
    width: "40%",
    borderInline: "1px solid #E5E5E5",
    [theme.fn.smallerThan("sm")]: {
      width: "100%",
      borderInline: "none",
      borderBottom: "1px solid #E5E5E5",
    },
  },
  tableParent3: {
    width: "20%",
    [theme.fn.smallerThan("sm")]: {
      width: "100%",
    },
  },
  tableParent4: {
    width: "10%",
    borderLeft: "1px solid #E5E5E5",
  },
  table: {
    "& thead": {
      "& tr th": {
        backgroundColor: "#F5F5F5",
        fontSize: 14,
        fontWeight: 700,
        color: "#000",
        fontFamily: "Inter",
        padding: "14px 12px",
      },
    },
    "& tbody": {
      "& tr td": {
        fontSize: 14,
        fontWeight: 400,
        color: "#000",
        fontFamily: "Inter",
        padding: "14px 12px",
        display: "flex",
        alignItems: 'center'
      },
    },
  },
  switch: {
    ".mantine-Switch-track": {
      width: 51,
      height: 31,
      borderRadius: 100,
      background: "rgba(120, 120, 128, 0.16)",
      border: "none",
    },

    ".mantine-Switch-thumb": {
      width: 27,
      height: 27,
      borderRadius: 100,
      background: "#FFF",
      boxShadow:
        "0 0 0 1px rgba(0, 0, 0, 0.04), 0 3px 8px 0 rgba(0, 0, 0, 0.15), 0 3px 1px 0 rgba(0, 0, 0, 0.06)",
    },

    "input:checked + .mantine-Switch-track": {
      background: "#34C759",
    },

    "input:checked + .mantine-Switch-track .mantine-Switch-thumb": {
      left: 2,
      transform: "translateX(20px)",
    },
  },
  tdAmount: {
    flex: 1,
    fontSize: 14,
    fontWeight: 400,
    color: "#00A991",
    fontFamily: "Inter",
    textAlign: "end"
  },
  switchTable: {
    "& tbody": {
      "& tr td": {
        padding: "9px 12px",
        display: "flex",
        justifyContent: "center",
      },
    },
  },
  paginationRow: {
    flexWrap: "wrap",
    "& .tableWidth": {
      width: "40%",
      [theme.fn.smallerThan("sm")]: {
        width: "100%",
      },
    },
  },
}));

export default useStyles;
